import RESTClient from 'signin-app/api/clients/rest-client';
export default class EmployeeApi {
    static checkIn(accessToken, employeeId, pin, groupId, estimatedCheckoutTime) {
        return RESTClient.postObservable(`v2/employees/${employeeId}/checkins`, {
            accessToken,
            pin,
            estimatedCheckoutTime,
            groupId,
        });
    }
    static checkOut(accessToken, employeeId) {
        return RESTClient.postObservable(`v2/employees/${employeeId}/checkout`, {
            accessToken,
        });
    }
}
